/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_game_controller_platform = /** @type {(inputs: {}) => string} */ () => {
	return `Kompatibilita`
};

const da_attributes_game_controller_platform = /** @type {(inputs: {}) => string} */ () => {
	return `Compatibilité`
};

const de_attributes_game_controller_platform = /** @type {(inputs: {}) => string} */ () => {
	return `Spielsteuerungsplattform`
};

const en_attributes_game_controller_platform = /** @type {(inputs: {}) => string} */ () => {
	return `Compatibilité`
};

const es_attributes_game_controller_platform = /** @type {(inputs: {}) => string} */ () => {
	return `plataforma del mando de juego`
};

const fr_attributes_game_controller_platform = /** @type {(inputs: {}) => string} */ () => {
	return `Compatibilité`
};

const hu_attributes_game_controller_platform = /** @type {(inputs: {}) => string} */ () => {
	return `Compatibilité`
};

const it_attributes_game_controller_platform = /** @type {(inputs: {}) => string} */ () => {
	return `Piattaforma del controller di gioco`
};

const nl_attributes_game_controller_platform = /** @type {(inputs: {}) => string} */ () => {
	return `Spelbesturingsplatform`
};

const pl_attributes_game_controller_platform = /** @type {(inputs: {}) => string} */ () => {
	return `Platforma kontrolera gier`
};

const pt_attributes_game_controller_platform = /** @type {(inputs: {}) => string} */ () => {
	return `Plataforma do controlador de jogo`
};

const sv_attributes_game_controller_platform = /** @type {(inputs: {}) => string} */ () => {
	return `Plattform för spelkontroll`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_game_controller_platform = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_game_controller_platform(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_game_controller_platform", locale)
	if (locale === "cs") return cs_attributes_game_controller_platform(inputs)
	if (locale === "da") return da_attributes_game_controller_platform(inputs)
	if (locale === "de") return de_attributes_game_controller_platform(inputs)
	if (locale === "en") return en_attributes_game_controller_platform(inputs)
	if (locale === "es") return es_attributes_game_controller_platform(inputs)
	if (locale === "fr") return fr_attributes_game_controller_platform(inputs)
	if (locale === "hu") return hu_attributes_game_controller_platform(inputs)
	if (locale === "it") return it_attributes_game_controller_platform(inputs)
	if (locale === "nl") return nl_attributes_game_controller_platform(inputs)
	if (locale === "pl") return pl_attributes_game_controller_platform(inputs)
	if (locale === "pt") return pt_attributes_game_controller_platform(inputs)
	return sv_attributes_game_controller_platform(inputs)
};
export { attributes_game_controller_platform as "attributes.game_controller_platform" }